export default __webpack_public_path__ + "static/media/Cochrane_DEU_rgb.7352a1df.svg";